'use client';

import { useEffect, useState } from 'react';
// import { usePathname } from 'next/navigation';

import { useEditableDotCMSPage } from '@dotcms/react';
// import { getUVEState, initUVE, sendMessageToUVE } from '@dotcms/uve';
// import { DotCMSUVEAction } from '@dotcms/types';

// import { client } from '@/app/utils/client';

import Contentlet from '@/components/shared/contentlet';
import customRenderers from '@/components/block-editor';
import { NewsletterForm } from '@/components/shared/newsletter-form/NewsletterForm';
import TableOfContents from '@/components/shared/table-of-contents/TableOfContents';
import { DetailHeader } from './components/DetailHeader';
import { RelatedPosts } from './components/RelatedPosts';
import { normalizeDetailPageContent } from './utils';
import { DotBlockEditor } from '../decodeTextBlock';
import { isBlockEditorEmpty } from '@/app/utils';

export function DetailPage({
    pageResponse,
    relatedPost,
    customPageBlocks = customRenderers,
    maxLimit = 4
}) {
    // const pathname = usePathname();
    // The hook returns undefined until UVE resolves a draft/non-live page, so read defensively.
    const pageAsset = useEditableDotCMSPage(pageResponse)?.pageAsset;

    const urlContentMap = pageAsset?.urlContentMap ?? {};
    const normalizedContent = normalizeDetailPageContent(urlContentMap);

    const [contentlet, setContentlet] = useState(urlContentMap);
    const [detailContent, setDetailContent] = useState(normalizedContent);

    // Sync state when pageAsset changes from the hook
    useEffect(() => {
        const updatedUrlContentMap = pageAsset?.urlContentMap ?? {};
        const updatedNormalizedContent = normalizeDetailPageContent(updatedUrlContentMap);
        setContentlet(updatedUrlContentMap);
        setDetailContent(updatedNormalizedContent);
    }, [pageAsset]);

    // useEffect(() => {
    //     if (!getUVEState()) {
    //         return;
    //     }

    //     /**
    //      * Send a message to the editor to let it know that the client is ready.
    //      * This is a temporary workaround to avoid the editor to be stuck in the loading state.
    //      * This will be removed once the editor is able to detect when the client is ready without use DotcmsLayoutComponent.
    //      */
    //     initUVE();
    //     sendMessageToUVE({ action: DotCMSUVEAction.CLIENT_READY });

    //     client.editor.on('changes', ({ urlContentMap }) => {
    //         const normalizedContent = normalizeDetailPageContent(urlContentMap);
    //         setContentlet(urlContentMap);
    //         setDetailContent(normalizedContent);
    //     });
    // }, [pathname]);

    return (
        <main className="flex w-full flex-col gap-0">
            <Contentlet contentlet={contentlet}>
                <DetailHeader {...detailContent} />
                <div className="p-4 pt-11 md:p-16 lg:px-32">
                    <div className="container flex gap-6 p-0 lg:gap-9">
                        <article className="prose w-full max-w-fit break-words lg:w-2/3">
                            {!isBlockEditorEmpty(detailContent.body) && (
                                <DotBlockEditor
                                    customRenderers={customPageBlocks}
                                    blocks={detailContent.body}
                                />
                            )}
                        </article>
                        <div
                            className="hidden flex-col gap-5 lg:flex lg:w-1/3"
                            style={{ position: 'sticky', top: '7.5rem', alignSelf: 'flex-start' }}>
                            <TableOfContents />
                            <NewsletterForm />
                        </div>
                    </div>
                </div>
            </Contentlet>
            {!!relatedPost?.length && <RelatedPosts maxLimit={maxLimit} posts={relatedPost} />}
        </main>
    );
}
